/** Vibe Studio gamification blocks for label 16018 (ICE2026 / play.smartico.ai). */

const CACHE_BUST_PARAM = '_sm_cb'

/** Bypass HTTP + SDK in-memory script cache so a Studio republish is picked up on remount. */
export function cacheBustWidgetUrl(url: string): string {
	const parsed = new URL(url)
	const pathPrefix = `${parsed.origin}${parsed.pathname}`
	document.querySelectorAll('script[src]').forEach((node) => {
		const script = node as HTMLScriptElement
		if (script.src.startsWith(pathPrefix)) {
			script.remove()
		}
	})
	parsed.searchParams.set(CACHE_BUST_PARAM, String(Date.now()))
	return parsed.toString()
}

export const WIDGETS = {
	/** play: tournaments on the main page (lp_template_id 100000) — published */
	tournaments: {
		url: 'https://78615d8a-9249-42b0-99c9-e004fb6db4f4.ld-int.dev/widget/widget.js',
		domId: 'smr-widget-tournaments',
	},
	/** play: inbox (lp_template_id 100002) — published */
	inbox: {
		url: 'https://2e1c9606-a23c-4942-8e4f-b3e0acaf354a.ld-int.dev/widget/widget.js',
		domId: 'smr-widget-inbox',
	},
	/** play: mini-games in the left menu (lp_template_id 100001) — publish in Studio before this loads */
	minigames: {
		url: 'https://9092f195-b93a-4f65-8424-1c2c2d166573.ld-int.dev/widget/widget.js',
		domId: 'smr-widget-minigames',
	},
	/** play: Leaderboards page (lp_template_id 100025) — published */
	leaderboards: {
		url: 'https://1e69f0ab-fda3-4636-933a-783bb614156d.ld-int.dev/widget/widget.js',
		domId: 'smr-widget-leaderboards',
	},
	/** play: navigation section in homepage (lp_template_id 100613) — published */
	homeNav: {
		url: 'https://8f35d0b9-70e2-468c-8df5-40dfba8be33e.ld-int.dev/widget/widget.js',
		domId: 'smr-widget-home-nav',
	},
	/** play: Raffle page (widget id 158) — published */
	raffle: {
		url: 'https://eb17ad1f-2093-4c35-9fc1-e32c3a92aef3.ld-int.dev/widget/widget.js?id=158',
		domId: 'smr-widget-raffle',
	},
	/** play: Prize Drop page — published */
	prizeDrop: {
		url: 'https://3e1ac4c3-d468-490d-8587-05044065b2cc.ld-int.dev/widget/widget.js',
		domId: 'smr-widget-prize-drop',
	},
	/** play: Missions on the main page (lp_template_id 100028) — published */
	missions: {
		url: 'https://445358d5-ff23-4a38-bc1a-140a80c81726.ld-int.dev/widget/widget.js',
		domId: 'smr-widget-missions',
	},
	/** play: Store page — published */
	store: {
		url: 'https://c1189384-dfc4-403a-ae8e-7adae64bbca8.ld-int.dev/widget/widget.js',
		domId: 'smr-widget-store',
	},
	/** play: Missions page — published */
	missionsPage: {
		url: 'https://a613cf36-8c1c-41c8-8ce3-08e6fe0e4df3.ld-int.dev/widget/widget.js',
		domId: 'smr-widget-missions-page',
	},
	/** play: My Collectibles page — published */
	collectibles: {
		url: 'https://d1211506-5f45-467f-8bca-78ef51a6ec7f.ld-int.dev/widget/widget.js',
		domId: 'smr-widget-collectibles',
	},
	/** play: Tournaments page — published */
	tournamentsPage: {
		url: 'https://71e190f4-5af3-4aa2-94b8-89ea81900b03.ld-int.dev/widget/widget.js',
		domId: 'smr-widget-tournaments-page',
	},
	/** play: Minigames page — published */
	minigamesPage: {
		url: 'https://1a26cbb5-2543-41a3-a68f-0516e8bc1cbd.ld-int.dev/widget/widget.js',
		domId: 'smr-widget-minigames-page',
	},
	/** play: VIP / Levels page — published */
	vip: {
		url: 'https://9ae97a51-5c6e-4f9a-96e6-2fe6e880185b.ld-int.dev/widget/widget.js',
		domId: 'smr-widget-vip',
	},
	/** play: Quiz page — published */
	quiz: {
		url: 'https://9f76efcb-99a2-457b-93b9-c581b346f1cb.ld-int.dev/widget/widget.js',
		domId: 'smr-widget-quiz',
	},
	/** play: MatchX / Sports Prediction page — published */
	matchx: {
		url: 'https://5861d37e-37ea-49e1-8c13-7d0ba9aed9d4.ld-int.dev/widget/widget.js',
		domId: 'smr-widget-matchx',
	},
	/** play: Jackpot page — published */
	jackpot: {
		url: 'https://753f6ac0-f3a3-4067-9c00-085ff982f9b0.ld-int.dev/widget/widget.js',
		domId: 'smr-widget-jackpot',
	},
	/** play: Jackpot on the main page, below Top Games — published */
	homeJackpot: {
		url: 'https://ecc0ca26-0a9c-48c1-b14d-7ab8ecf5b5ea.ld-int.dev/widget/widget.js',
		domId: 'smr-widget-home-jackpot',
	},
	/** play: Vibe Studio Landing page (lp_template_id 100645) — published */
	vibeStudio: {
		url: 'https://81a65b55-9746-45ad-9d85-21fe934fc98d.ld-int.dev/widget/widget.js',
		domId: 'smr-widget-vibe-studio',
	},
} as const

const PAGE_LOAD_KEY = String(Date.now())

function withPageLoadKey(url: string): string {
	const parsed = new URL(url)
	parsed.searchParams.set(CACHE_BUST_PARAM, PAGE_LOAD_KEY)
	return parsed.toString()
}

export const SLOT_GAME_WIDGET_URL = withPageLoadKey('https://4f51bd63-853d-4177-bc93-a48624db4715.ld-int.dev/widget/widget.js')

export const GAME_WIDGET_URLS: Record<string, string> = {
	'treasure-seeker': SLOT_GAME_WIDGET_URL,
	'dragon-fortune': SLOT_GAME_WIDGET_URL,
	'ocean-riches': SLOT_GAME_WIDGET_URL,
	'donut-delight': SLOT_GAME_WIDGET_URL,
	'pharaohs-fortune': SLOT_GAME_WIDGET_URL,
	'mystic-woods': SLOT_GAME_WIDGET_URL,
	'olympian-riches': SLOT_GAME_WIDGET_URL,
	'mystic-spin': SLOT_GAME_WIDGET_URL,
	'love-spin': SLOT_GAME_WIDGET_URL,
	'luxe-spins': SLOT_GAME_WIDGET_URL,
	'viking-fortune': SLOT_GAME_WIDGET_URL,
	'witchs-spell': SLOT_GAME_WIDGET_URL,
}

export function gameWidgetUrlForPath(pathname: string): string | undefined {
	if (!pathname.includes('/game/')) return undefined
	return GAME_WIDGET_URLS[decodeURIComponent(pathname.split('/game/')[1] ?? '')]
}
